import { render } from "./ConfigurationsList.vue?vue&type=template&id=4dd9e4e8&scoped=true&ts=true"
import script from "./ConfigurationsList.vue?vue&type=script&lang=ts"
export * from "./ConfigurationsList.vue?vue&type=script&lang=ts"

import "./ConfigurationsList.vue?vue&type=style&index=0&id=4dd9e4e8&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd9e4e8"]])

export default __exports__